import { render, staticRenderFns } from "./EmptyListPlaceholderNew.vue?vue&type=template&id=43934f64"
import script from "./EmptyListPlaceholderNew.vue?vue&type=script&lang=ts"
export * from "./EmptyListPlaceholderNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43934f64')) {
      api.createRecord('43934f64', component.options)
    } else {
      api.reload('43934f64', component.options)
    }
    module.hot.accept("./EmptyListPlaceholderNew.vue?vue&type=template&id=43934f64", function () {
      api.rerender('43934f64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/EmptyListPlaceholderNew.vue"
export default component.exports